import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import { initAnalytics } from './services/firebase'

// Initialize analytics (non-blocking)
initAnalytics().catch(err => console.warn('Analytics initialization failed:', err));

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)
